import src from "IMAGE";
export default { src, width: 218, height: 39, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AHR8ddo/MDNqHR4eTyEhIlgeHh9TJCUmXyUlJlwkJSVik3AHyLPVVQ0AAAAASUVORK5CYII="};
